(ns hypnos.backoffice.tile.field.anatomy-head
  "Field for the head."
  (:require [clojure.string :as str]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/head)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/height)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       4
          :width      4
          :max-length 4
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/head-height])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/head-height]
                                 new-value)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]
     [:div.field.is-narrow
      [:div.field.has-addons
       [:div.control
        [:a.button.is-static (tr :ui.label/width)]]
       [:p.control
        [:input.input
         {:type       :text
          :size       4
          :width      4
          :max-length 4
          :disabled   disabled
          :value      (when-let [val (get-in @state [:anatomy :anatomy/head-width])] val)
          :on-change  (fn [e]
                        (let [val       (-> e .-target .-value)
                              new-value (when-not (str/blank? val) (int val))]
                          (swap! state assoc-in
                                 [:anatomy :anatomy/head-width]
                                 new-value)))}]]
       [:div.control
        [:a.button.is-static (tr :ui.label/mm)]]]]]]))
